import React from "react";
import isMobileDevice from "is-mobile";

export const AppContext = React.createContext({
    isMobile: isMobileDevice(),
    me: {}
});
